/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoices_TitleInputs */

const de_billing_invoices_title = /** @type {(inputs: Billing_Invoices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen`)
};

/** @type {(inputs: Billing_Invoices_TitleInputs) => LocalizedString} */
const en_billing_invoices_title = de_billing_invoices_title;

/**

* @param {Billing_Invoices_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_invoices_title = /** @type {((inputs?: Billing_Invoices_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoices_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_billing_invoices_title(inputs)
	return en_billing_invoices_title(inputs)
});